import { useState } from 'react';

import { SmallBoldUnderlinedTextDropdown } from '#src/components/SmallBoldUnderlinedTextDropdown/SmallBoldUnderlinedTextDropdown.tsx';

export type DeliveredIndicator = boolean | undefined;

export const useDeliveredIndicatorState = () => {
  const [deliveredIndicator, setDeliveredIndicator] =
    useState<DeliveredIndicator>(false);

  return {
    deliveredIndicator,
    setDeliveredIndicator,
  };
};

type Props = ReturnType<typeof useDeliveredIndicatorState>;

export const DeliveredIndicatorPicker = ({
  deliveredIndicator,
  setDeliveredIndicator,
}: Props) => (
  <SmallBoldUnderlinedTextDropdown
    setValue={setDeliveredIndicator}
    options={[
      {
        label: 'All',
        value: undefined,
      },
      {
        label: 'Delivered',
        value: true,
      },
      {
        label: 'Undelivered',
        value: false,
      },
    ]}
    value={deliveredIndicator}
  />
);
